import { List, Modal } from "antd";
import { ProductRuleDto } from "interfaces/apiTypes";
import { Subtitle } from "components/typography";
import { RuleListCard } from "./ruleListCard";

interface RuleListProps {
  rules: ProductRuleDto[];
  onDelete: (ruleId: number) => void;
  showModal: (rule: ProductRuleDto) => void;
  onPageChange: (page: number, pageSize: number) => void;
  currentPageSize: number;
  total: number;
}

export const RuleList = ({ rules, onDelete, showModal, onPageChange, currentPageSize, total }: RuleListProps) => {
  if (!rules) {
    return <div>Loading...</div>;
  }

  const handleDelete = (rule: ProductRuleDto) => {
    Modal.confirm({
      title: 'Bekräfta borttagning',
      content: (
        <>
          Är du säker på att du vill ta bort regeln "{rule.name}"?
          <br />
          Reglerna kommer att uppdateras för alla produkter som matchar denna regel.
        </>
      ),
      okText: 'Ja, ta bort',
      cancelText: 'Avbryt',
      okButtonProps: { danger: true },
      onOk: () => onDelete(rule.id ?? 0),
    });
  };

  return (
    <div
      style={{
        flex: "0 0 30%",
        maxWidth: "30%",
        padding: "1rem",
        minWidth: 0,
        maxHeight: "calc(100vh - 280px)",
        overflowY: "auto",
      }}
    >
      {/* Matches search field height on the ranking column so lists start on the same row */}
      <div
        style={{
          height: 32,
          marginBottom: 6,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Subtitle>Regler</Subtitle>
      </div>
      <List
        className="demo-loadmore-list"
        itemLayout="horizontal"
        dataSource={rules}
        style={{ marginBottom: "1rem" }}
        split={false}
        pagination={{
          pageSize: currentPageSize,
          showTotal(total, range) {
            return `Visar ${range[0]}-${range[1]} av ${total} regler`;
          },
          total: total,
          style: { textAlign: 'center', marginTop: '1rem' },
          onChange: (page, pageSize) => {
            onPageChange(page, pageSize);
          }
        }}
        renderItem={(item) => (
          <List.Item style={{ padding: 0, marginBottom: 10, border: 'none' }}>
            <div style={{ width: '100%' }}>
              <RuleListCard
                rule={item}
                onEdit={showModal}
                onDelete={handleDelete}
              />
            </div>
          </List.Item>
        )}
      />
    </div>
  );
};
